module.exports = __webpack_public_path__ + "static/media/celebrate.a55eb766.webp";